<template>
  <div class="uni-mmask">
    <div
      :style="{ top: offsetTop + 'px' }"
      class="b-uni-mmask"
      @click="hide"
      @touchmove.stop.prevent="moveHandle"
    />
    <div class="b-moreBack" :style="{bottom:'0px',paddingBottom: '0px'}" id="bMBack">
        <div class="buy-titleView">
            <div class="title-b-btn"
             v-for="(item,index) in title"
             :key="index"
             @click="titleClick(item)">{{item.name}}</div>
        </div>
        <div class="b-uni-mpopup">
            <div class="b-btn"
                v-for="(item,index) in list"
                :key="index"
                @click="clickPopup(item)"
            >
            <div class="b_main_view">
              <span :class="[item.tip.length>0 ? 'b-l-active': 'b-label']">{{item.name}}</span>
              <span class="b-up-item-more-button" v-if="item.tip.length>0">{{item.tip}}</span>
            </div>
            <div class="b_main_view">
              <span class="b-sub-item-more-button"
                  v-if="item.subName.length>0">{{item.subName}}</span>
              <span class="b-sub-item-more-dt" :style="{color: getDTYColor(item.dt_y)}"
                  v-if="item.dt_y">{{getDTY(item.dt_y)}}</span>
            </div>
            </div>
        </div>
        <div class="cancel-b-sp-btn"></div>
        <div class="cancel-b-btn" @click="cancelhide">取消</div>
    </div>
  </div>
</template>

<script>
import {
  detailPushPage,
} from '@/utils/nativeBridge';
import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';

export default {
  name: 'myPopup',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    position: {
      type: String,
      // top - 顶部， middle - 居中, bottom - 底部
      default: 'middle',
    },
    mode: {
      type: String,
      default: 'insert',
    },
    msg: {
      type: String,
      default: '',
    },
    h5Top: {
      type: Boolean,
      default: false,
    },
    buttonMode: {
      type: String,
      default: 'bottom',
    },
    title: {
      type: Object,
      default: () => [],
    },
    list: {
      type: Array,
      default: () => [],
    },
    tabSelected: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isIphoneX: false,
      offsetTop: 0,
    };
  },
  watch: {
    h5Top(newVal) {
      if (newVal) {
        this.offsetTop = 0;
      } else {
        this.offsetTop = 0;
      }
    },
  },
  created() {
    let offsetTop = 0;
    if (!this.h5Top) {
      offsetTop = 0;
    } else {
      offsetTop = 0;
    }
    this.offsetTop = offsetTop;
    this.isIphoneX = false;
  },
  methods: {
    getDTY(value) {
      const y = parseFloat(value);
      if (y > 0) {
        return `+${y.toFixed(2)}%`;
      }
      if (y < 0) {
        return `${y.toFixed(2)}%`;
      }
      return '0.00%';
    },
    getDTYColor(value) {
      const y = parseFloat(value);
      if (y > 0) {
        return '#FF4400';
      }
      if (y < 0) {
        return '#12b412';
      }
      return '#000000';
    },
    cancelhide() {
      this.hide();
      if (!isEmpty(this.list)) {
        const item = this.list[0];
        if (item.cancelclickpoint) {
          this.reportMonitor(item.cancelclickpoint);
        }
      }
    },
    hide() {
      this.$emit('hidePopup');
    },
    closeMask() {
      if (this.mode === 'insert') {
        this.$emit('hidePopup');
      }
    },
    moveHandle() {},
    titleClick(item) {
      // this.clickPopup(item);
      const { LinkType, LinkTo } = item.link;
      detailPushPage({
        type: LinkType,
        url: LinkTo,
      });
      if (item.clickpoint) {
        this.reportMonitor(item.clickpoint);
      }
    },
    clickPopup(item) {
      this.hide();
      const { LinkType, LinkTo } = item.link;
      detailPushPage({
        type: LinkType,
        url: LinkTo,
      });
      if (item.clickpoint) {
        this.reportMonitor(item.clickpoint);
      }
    },
  },
};
</script>
<style lang="less">
.b-uni-mmask {
  position: fixed;
  z-index: 99999999;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.0);
}
.b-moreBack{
  position: fixed;
  flex-direction: column;
  bottom: 0px;
  width: 100%;
  z-index: 99999999;
  background-color: #ffffff;
}
.b-uni-mpopup {
  display: flex;
  flex-direction: column;
  z-index: 99999999;
  background-color: #ffffff;
}
.b-item-more-button {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex: 1;
    position: relative;
  }
  .b-sub-item-more-button {
    font-family: PingFangSC-Regular;
    font-size: 28px;
    color: #999;
    margin-top: 16px;
  }
  .b-sub-item-more-dt{
    font-size: 28px;
    // color: #ff4400;
    margin-top: 16px;
  }
  .b-up-item-more-button {
    border: 2px solid #ff4400;
    font-family: PingFangSC-Regular;
    font-size: 20px;
    padding-top: 2px;
    padding-bottom: 2px;
    padding-left: 6px;
    padding-right: 6px;
    border-radius: 4px;
    text-align: center;
    color: #ff4400;
    line-height: 30px;
    height: 30px;
    background: #ffffff;
    margin-left: 10px;
  }
  .b-l-active {
    font-family: PingFangSC-Regular;
    font-size: 34px;
    text-align: center;
    line-height: 34px;
    height: 34px;
    white-space:nowrap;
    background: #ffffff;
    color: #ff4400;
  }
  .b-label {
    font-family: PingFangSC-Regular;
    font-size: 34px;
    color: #333333;
    white-space:nowrap;
    text-align: center;
    line-height: 34px;
    height: 34px;
    background: #ffffff;
  }
.b-btn {
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  padding-top: 32px;
  padding-bottom: 32px;
  border-bottom: 1px solid #efeff4;
}
.cancel-b-sp-btn {
  height: 10px;
  width: 100%;
  background: #eee;
}
.buy-titleView{
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  padding-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eeeeee;
}
.title-b-btn {
  font-size: 28px;
  text-align: center;
  margin-top: 15px;
  margin-bottom: 15px;
  color: rgba(16, 134, 255, 1);
  background-color: #ffffff;
}
.cancel-b-btn {
  padding-top: 36px;
  padding-bottom: 36px;
  font-size: 34px;
  text-align: center;
  background-color: #ffffff;
}

.b_main_view{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex: 1;
}
.rightV{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
